// extracted by mini-css-extract-plugin
export default {"cls1":"jxhdeefdbvyeBZ0WJrcO","cls2":"Tj186sRSRllq5LBPpkgd jxhdeefdbvyeBZ0WJrcO","collapsed":"lm17nyKMubCvKtgxwQ1t"};